/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { CustomerPortalIntegrationType } from '../../contexts/CustomerPortalContext';

type WebsocketUrls = {
	tokenUrl: string | null;
	webSocketUrl: string | null;
};

const DEFAULT_RESPONSE = {
	tokenUrl: null,
	webSocketUrl: null
};

export function getWebsocketUrlsFromUserData( userData: CustomerPortalIntegrationType[ 'customerPortalAccount' ] ): WebsocketUrls {
	const subscriptionIndex = 0;
	const environmentIndex = 0;

	if ( !userData ) {
		return { ...DEFAULT_RESPONSE };
	}

	const subscription = userData.subscriptions.at( subscriptionIndex );

	if ( !subscription ) {
		return { ...DEFAULT_RESPONSE };
	}

	const environment = subscription.environments.at( environmentIndex );

	if ( !environment ) {
		return { ...DEFAULT_RESPONSE };
	}

	const { developmentToken, websocket } = environment.urls;

	return {
		tokenUrl: developmentToken,
		webSocketUrl: websocket
	};
}
